import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_DETALLE_ALMACENAJE_ESPECIAL } from '../../../../config/tables'

function DetalleAlmacenajeEspecialView () {
  return (
    <MuiTable id={TABLA_DETALLE_ALMACENAJE_ESPECIAL} />
  )
}

export default DetalleAlmacenajeEspecialView
